import React from 'react'
import AuthNavbar from "../components/AuthNavbar/AuthNavbar"
import HomeTitle from "../components/HomeTitle/HomeTitle"
import ExportBox from "../components/ExportBox/ExportBox"

import Table from "../components/Table/Table"
import { Container } from "react-bootstrap"
import { useEffect, useState } from "react"
import axios from "axios"
import { useDispatch, useSelector } from "react-redux"
import { getClasses } from '../hooks/Classes'

function Classes() {
    const userinfo = useSelector((state) => state);
    const [items, setItems] = useState([])
        const { currentLocal } = useSelector((state) => state.currentLocal);
const dispatch=useDispatch()
    const headerIterm = [
        currentLocal.home.ID,
        currentLocal.home.namePlaceholder,
        currentLocal.home.stages,
        currentLocal.home.grades,
        currentLocal.home.MaxStudents,
        currentLocal.home.sessionnumber,
        currentLocal.home.SelectTimeTable
    ]
    const getAllApis = async () => {

        await axios
            .get(`https://nanosoft.technology/taarteb/api/classes`, {
                headers: {
                    Authorization: `Bearer ${userinfo.auth.userArray.access_token}`
                }
            })
            .then(async (res) => {
                setItems(res.data.data.data)
                dispatch(getClasses(res.data.data.data))

            })
            .catch((error) => {

                



            });
    }
    useEffect(() => {
   
        getAllApis()

    }, [])

  return (
    <div className="px-0 my-3 w-100 dashboard_content">
    <Container>
        <div className="d-flex flex-column w-100">
            <AuthNavbar />
            <div className="mt-5 mx-3">
                <HomeTitle title={currentLocal.home.classes} />

                <ExportBox
                     title={""}
                    paragrapg={' '}
                    addingBtn={currentLocal.home.addclass}
                    exportState={false}

                />

                <Table
                    data={items}
                    headerIterm={headerIterm}
                    onDataChanged={getAllApis}
                                        onSubmitAttendance={()=>{}}


                />


            </div>

        </div>
    </Container>
</div>
  )
}

export default Classes
